export const CHECK_WSPOSITIONS = 'CHECK_WSPOSITIONS';
export const CHECK_WSPOSITIONS_SUCCESS = 'CHECK_WSPOSITIONS_SUCCESS';
export const CHECK_WSPOSITIONS_ERROR = 'CHECK_WSPOSITIONS_ERROR';
